export default __webpack_public_path__ + "static/media/background-metaverse.1e9f2886.png";